<template>
  <div>
    <div>
      <FilterCard :applied-filter-count="appliedFilterCount -1">
        <b-row class="mb-1">
          <b-col
            cols="6"
            md="3"
          >
            <b-form-checkbox
              id="v-returned-invoices-only"
              v-model="filters.return_charge"
              value="not_null"
              :unchecked-value="''"
            >
              Returned invoices only
              <feather-icon
                id="returned-invoices-only-tooltip"
                icon="InfoIcon"
                size="14"
                class="text-muted ml-25"
              />
              <b-tooltip
                target="returned-invoices-only-tooltip"
                triggers="hover"
              >
                Show only invoices where return charge is present.
              </b-tooltip>
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label="Invoice No"
              label-for="v-invoice-no"
            >
              <b-form-input
                id="v-invoice-no"
                v-model="filters['invoice_no']"
                placeholder="Search"
              />
            </b-form-group>
          </b-col>
          <b-col
            v-if="!walkingCustomer"
            cols="6"
            md="3"
          >
            <b-form-group
              label="Merchant"
              label-for="merchant_name"
            >
              <v-select
                v-model="filters['merchant_id']"
                :options="merchantOptions"
                :reduce="option => option.id"
                label="name"
                placeholder="Select Merchant"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            v-if="walkingCustomer"
            cols="6"
            md="3"
          >
            <b-form-group
              label="Walking Customer"
              label-for="senderName"
            >
              <v-select
                v-model="filters['merchant_id']"
                :options="walkingCustomers"
                :reduce="option => option.id"
                label="name"
                autocomplete="nope"
                placeholder="Select Walking Customer"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            v-if="!walkingCustomer"
            cols="6"
            md="3"
          >
            <b-form-group
              label="Status"
              label-for="invoice_status"
            >
              <v-select
                v-model="filters['status']"
                :options="statusOptions"
                :reduce="option => option.key"
                label="name"
                placeholder="Select Status"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            v-if="!walkingCustomer"
            cols="6"
            md="3"
          >
            <b-form-group
              label="Invoice Type"
              label-for="invoice_type"
            >
              <v-select
                v-model="filters['invoice_amount_after_taxes']"
                :options="invoiceTypeOptions"
                :reduce="option => option.key"
                label="name"
                placeholder="Select Type"
              >
                <template v-slot:option="option">
                  {{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col
            v-if="!walkingCustomer"
            cols="6"
            md="3"
          >
            <b-form-group
              label="Invoice Date"
              label-for="Invoice-Date"
            >
              <div class="position-relative">
                <AdvancedDateFilter
                  :date-value="filters['created_at']"
                  :opens="'right'"
                  @update="updateDateRange('created_at', $event)"
                />
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Apply and Clear Filters -->
        <b-row class="mt-1 justify-content-end">
          <b-col cols="auto">
            <filter-buttons
              :filter-data="filters"
              :apply-filters="applyFilters"
              :clear-filters="clearFilters"
            />
          </b-col>
        </b-row>
      </FilterCard>
    </div>
    <div
      v-if="!walkingCustomer"
    >
      <b-row class="match-height">
        <b-col
          sm="12"
          md="6"
          lg="4"
        >
          <overview-card
            title="All Invoices"
            :subtitle="allInvoice.total !== undefined && allInvoice.total !== null ? allInvoice.total + ' Invoices' : 'Loading...'"
            :sum="(allInvoice.count)"
            :border-variant="selectedCard == 'allInvoice' ? 'primary' : ''"
            tooltip-description="Displays the total sum of all invoices, both payable and receivable."
            icon="MenuIcon"
            indicator-color="#67b7b7 "
            @click.native="onCardSelect('allInvoice','');"
          />
        </b-col>
        <b-col
          sm="12"
          md="6"
          lg="4"
        >
          <overview-card
            title="Payable Invoice"
            :subtitle="payableInvoice.total !== undefined && payableInvoice.total !== null ? payableInvoice.total + ' Invoices' : 'Loading...'"
            :sum="(payableInvoice.count)"
            :border-variant="selectedCard == 'payableInvoice' ? 'primary' : ''"
            tooltip-description="Shows the total amount of invoices that are due for payment."
            icon="PlusSquareIcon"
            indicator-color="#6a76b0"
            @click.native="onCardSelect('payableInvoice','payable','invoice_amount_after_taxes');"
          />
        </b-col>
        <b-col
          sm="12"
          md="12"
          lg="4"
        >
          <overview-card
            title="Receivable Invoice"
            :subtitle="receivableInvoice.total !== undefined && receivableInvoice.total !== null ? receivableInvoice.total + ' Invoices' : 'Loading...'"
            :sum="(receivableInvoice.count)"
            :border-variant="selectedCard == 'receivableInvoice' ? 'primary' : ''"
            tooltip-description="Shows the total amount of invoices that are pending to be received."
            icon="MinusSquareIcon"
            indicator-color="#64c778"
            @click.native="onCardSelect('receivableInvoice','receivable','invoice_amount_after_taxes');"
          />
        </b-col>
      </b-row>
    </div>
    <div>
      <b-card
        no-body
      >
        <div
          class="m-2"
        >
          <b-row class="d-sm-flex align-items-start">
            <b-col
              md="12"
              lg="8"
              class="d-block d-sm-flex flex-wrap justify-content-start align-items-center mb-1 mb-md-0"
            >
              <b-button
                v-if="!walkingCustomer"
                v-can="'merchant-finance-paid'"
                :disabled="depositSelected.length === 0"
                class="mr-1 add-margin-bottom"
                variant="success"
                @click="onClickMakePayment()"
              >
                Make Payment
              </b-button>
              <b-button
                v-if="!walkingCustomer"
                v-can="'merchant-finance-create'"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                class="custom-button-color add-margin-bottom"
                @click="onClickNewInvoice()"
              >
                <feather-icon icon="PlusIcon" />
                Add New Invoice
              </b-button>
            </b-col>
            <b-col
              class="d-flex justify-content-end align-items-center mb-1 mb-md-0"
            >
              <ReportTableButtons
                :items="items"
                :json_fieldz="json_fields"
                :name="`${walkingCustomer ? 'CustomerInvoices' : 'MerchantInvoices'} - Page ${page}.xls`"
                :bulkname="walkingCustomer ? 'CustomerInvoices.xls' : 'MerchantInvoices.xls'"
                :fetch="fetchDataForMerchantNoPagination"
                :use-queue-download="true"
                @refresh="onClickRefresh"
                @queue-download="downloadQueueExcel"
              />
            </b-col>
          </b-row>
          <b-row v-if="!walkingCustomer">
            <div
              class="font-weight-bolder text-muted ml-1 mt-1"
            >
              {{ `${depositSelected.length} record${depositSelected.length === 1 ? '':'s'}` }} selected
            </div>
          </b-row>
        </div>

        <!-- table -->
        <b-overlay
          id="overlay-background"
          blur="10px"
          opacity="0.30"
          rounded="sm"
          variant="light"
        >
          <b-table
            :per-page="perPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            hover
            responsive
            striped
            show-empty
            sticky-header="100vh"
            class="hide-vertical-scroll"
            @sort-changed="sortChanged"
          >
            <template #empty>
              <TableDataFetching
                :rows="items"
                :data-loading="dataLoading"
              />
            </template>
            <template #head()="{ field }">
              <div
                class="sortable-header"
              >
                <span class="header-text">{{ field.label }}</span>
                <feather-icon
                  v-if="field.sortable"
                  :icon="sort === field.key
                    ? 'ArrowUpIcon'
                    : 'ArrowDownIcon'"
                  size="14"
                />
              </div>
            </template>
            <template #head(id)>
              <div class="d-flex align-items-start">
                <div>
                  <b-form-checkbox
                    id="selectAllCheckbox"
                    v-model="selectAllCheckbox"
                    name="selectAllCheckbox"
                    @change="onClickSelectAllCheckbox()"
                  />
                </div>
              </div>
            </template>
            <template #cell(id)="data">
              <div class="d-flex align-items-start">
                <div>
                  <div class="font-weight-bolder">
                    <b-form-checkbox
                      v-model="depositSelected"
                      :value="data.item.id"
                    />
                  </div>
                </div>
              </div>
            </template>
            <template #cell(merchant.name)="data">
              <div class="d-flex align-items-start">
                <div>
                  <div class="">
                    {{ walkingCustomer ? data.item.walking_customer.name : `${data.value}${data.item.merchant.merchant_setting.merchant_type === 'cash' ? "&nbsp;[&nbsp;C&nbsp;]" : ''}` }}
                  </div>
                </div>
              </div>
            </template>
            <template #cell(merchant_business)="data">
              <span>{{ data.item.merchant_business || '---' }}</span>
            </template>
            <template #cell(invoice_no)="data">
              <div class="d-flex align-items-center">
                <b-avatar
                  :text="avatarText(data.item.invoice_no)"
                  size="32"
                  variant="light-primary"
                />
                <div class="ml-1">
                  <div
                    class="font-weight-bolder text-primary"
                    @click="onClickInvoice(data.item.id)"
                  >
                    {{ data.value }}
                  </div>
                  <div class="font-small-2">
                    {{ __dateTimeFormatter(data.item.created_at) }}
                  </div>
                </div>
              </div>
            </template>
            <template #cell(commission_rate)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(collected_cod)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(delivery_charge)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(return_charge)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(commission_amount)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(total_tax_applied)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(invoice_amount)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(invoice_amount_after_taxes)="data">
              <span>{{ __numberWithCommas(data.value, true) }}</span>
            </template>
            <template #cell(deposited_date)="data">
              {{ __dateTimeFormatter(data.value) || '---' }}
            </template>
            <template #cell(approved_date)="data">
              {{ __dateTimeFormatter(data.value) || '---' }}
            </template>
            <template #cell(finance_current_status.key)="data">
              <finance-status-badge
                :status-key="data.value"
                :finance-status="statusOptions"
              />
              <div
                v-if="data.item.is_reversed_deposit"
                class="mt-1 d-flex justify-content-center"
              >
                <b-tooltip
                  :target="data.item.id.toString()"
                  triggers="hover"
                  variant="danger"
                >
                  Rejected Once
                </b-tooltip>
                <b-avatar
                  :id="data.item.id.toString()"
                  size="20"
                  style="background-color: #ffb5b5"
                >
                  <feather-icon
                    icon="ChevronsLeftIcon"
                    class="text-body align-middle"
                  />
                </b-avatar>
              </div>
            </template>
            <template #cell(action)="data">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                :class="items.length !== 1 ? 'dropdown-no-scroll':''"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="12"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  :to="{ name: walkingCustomer ? 'walking-finance-invoice' :'merchant-finance-invoice', params: { id: data.item.id } }"
                >
                  <feather-icon icon="BookIcon" />
                  View Invoice
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="data.item.receipt_url"
                  :href="`${bucketUrl}${data.item.receipt_url}`"
                  target="_blank"
                >
                  <feather-icon icon="EyeIcon" />
                  View Payment Slip
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="data.item.is_reversed_deposit"
                  @click="onClickShowRejectionReasons(data.item.id)"
                >
                  <feather-icon icon="BookIcon" />
                  Rejection Reasons
                </b-dropdown-item>
                <b-dropdown-item
                  v-can="'merchant-finance-show'"
                  :to="{ name: walkingCustomer ? 'walking-orders':'merchant-orders', params: { id: data.item.id } }"
                >
                  <feather-icon icon="ArchiveIcon" />
                  View Orders
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="!walkingCustomer"
                  @click="onClickOpenRequestPaymentModal(data.item.id)"
                >
                  <feather-icon icon="PocketIcon" />
                  View Payment Requests
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-overlay>

        <div class="mx-2 mb-2">
          <b-row
            cols="12"
          >
            <b-col
              class="d-flex align-items-center justify-content-sm-start"
              md="3"
            >
              <label class="width-75">Per page</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="pageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block width-125"
              />
            </b-col>
            <!-- Pagination -->
            <b-col
              class="d-flex align-items-center justify-content-sm-end"
              md="9"
            >
              <span class="text-muted pagination-text  mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
              <b-pagination
                v-model="page"
                :total-rows="(meta.total)? meta.total : 0"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
      <request-payment ref="merchant_payment_request_modal" />
    </div>
    <make-deposite-action ref="make_deposit_action_modal" />
    <rejection-details ref="rejection_detail_modal" />
  </div>
</template>

<script>
import {
  BFormCheckbox,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  VBModal,
  BOverlay,
  BAvatar,
  VBTooltip,
  BTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { bucketUrl } from '@/constants/config'
// eslint-disable-next-line import/no-cycle
import { avatarText } from '@core/utils/filter'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import FinanceStatusBadge from '@core/components/status/FinanceStatusBadge.vue'
import store from '@/store/index'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import MakeDepositeAction from '@/components/FinanceModuleForms/ActionForms/MakeDepositeAction.vue'
import requestPayment from '@/components/RequestPayment/requestPayment.vue'
import RejectionDetails from '@/components/FinanceModuleForms/InfoModals/RejectionDetailModal.vue'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import OverviewCard from '@core/components/overview-card/OverviewCard.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'

const FinanceRepository = RepositoryFactory.get('finance')
const MerchantRepository = RepositoryFactory.get('merchant')
const WalkingCustomerRepository = RepositoryFactory.get('walkingCustomer')

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    MakeDepositeAction,
    vSelect,
    AdvancedDateFilter,
    BTooltip,
    BOverlay,
    BCard,
    BTable,
    BAvatar,
    BFormCheckbox,
    BRow,
    BCol,
    BFormGroup,
    BPagination,
    BButton,
    BFormInput,
    BDropdown,
    BDropdownItem,
    requestPayment,
    FinanceStatusBadge,
    RejectionDetails,
    FilterButtons,
    OverviewCard,
    FilterCard,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  data() {
    let walkingCustomer = false
    if (window.location.href.includes('walking')) walkingCustomer = true
    return {
      bucketUrl,
      depositSelected: [],
      merchantOptions: [],
      walkingCustomers: [],
      filters: {
        created_at: {
          startDate: null,
          endDate: null,
        },
        return_charge: '',
      },
      dataLoading: false,
      sort: '',
      avatarText,
      perPage: 20,
      pageOptions: [10, 20, 50, 100],
      totalRows: 1,
      page: 1,
      meta: {},
      dir: false,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'id',
          sortable: false,
        },
        {
          key: 'invoice_no',
          label: 'Invoice',
          sortable: true,
        },
        {
          key: 'merchant.ref_no',
          label: 'Merchant ref no',
          sortable: true,
        },
        {
          key: 'merchant.name',
          label: walkingCustomer ? 'Walking Customer' : 'Merchant',
          sortable: true,
        },
        {
          key: 'merchant_business',
          label: walkingCustomer ? 'Customer' : 'Merchant Business',
          sortable: true,
        },
        {
          key: 'commission_rate',
          label: 'Commission Rate',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
        {
          key: 'collected_cod',
          label: 'Collected COD',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
        {
          key: 'commission_amount',
          label: 'Commission Amount',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: false,
        },
        {
          key: 'delivery_charge',
          label: 'Delivery Charge',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
        {
          key: 'return_charge',
          label: 'Return Charge',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
        {
          key: 'invoice_amount',
          label: 'Invoice Amount',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
        {
          key: 'total_tax_applied',
          label: 'Total Tax Amount',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
        {
          key: 'invoice_amount_after_taxes',
          label: 'After Tax Amount',
          thClass: 'text-right',
          tdClass: 'text-right',
          sortable: true,
        },
        // {
        //   key: 'invoice_amount',
        //   label: 'Invoice Amount',
        //   thClass: 'text-center',
        //   tdClass: 'text-center',
        //   sortable: true,
        // },
        {
          key: 'deposited_date',
          label: 'Paid Date',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'approved_date',
          label: 'Approved Date',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'finance_current_status.key',
          label: 'Status',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: true,
        },
        { key: 'action', label: 'Action', sortable: false },
      ],
      json_fields: {
        'Invoice NO': 'invoice_no',
        'Deposit Date': {
          field: 'created_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        ...(walkingCustomer
          ? {
            Customer: {
              field: 'walking_customer.name',
              callback: value => `"${value}"`,
            },
          }
          : {
            'Merchant Reference Number': {
              field: 'merchant.ref_no',
              callback: value => `"${value}"`,
            },
            Merchant: {
              field: 'merchant.name',
              callback: value => `"${value}"`,
            },
            'Merchant Business': {
              field: 'merchant_business',
              callback: value => `"${value}"`,
            },
          }),
        'Commission Rate': 'commission_rate',
        'Collected COD': 'collected_cod',
        'Commission Amount': 'commission_amount',
        'Delivery Charge': 'delivery_charge',
        'Return Charge': 'return_charge',
        'Invoice Amount': 'invoice_amount',
        'Total Tax Amount': 'total_tax_applied',
        'After Tax Amount': 'invoice_amount_after_taxes',
        ...(!walkingCustomer
          ? {
            'Paid Date': {
              field: 'deposited_date',
              // eslint-disable-next-line no-underscore-dangle
              callback: value => this.__dateTimeFormatter(value),
            },
          }
          : {}),
        'Approved Date': {
          field: 'approved_date',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        Status: 'finance_current_status.name',
      },
      items: [],
      statusOptions: [],
      invoiceTypeOptions: [
        {
          name: 'Payable',
          key: 'payable',
        },
        {
          name: 'Receivable',
          key: 'receivable',
        },
      ],
      walkingCustomer,
      selectAllCheckbox: false,
      allInvoice: { total: null, count: undefined },
      payableInvoice: { total: null, count: undefined },
      receivableInvoice: { total: null, count: undefined },
      selectedCard: 'allInvoice',
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchDataForMerchant()
      },
    },
    deep: true,
    page() {
      this.fetchDataForMerchant()
    },
    perPage() {
      this.fetchDataForMerchant()
    },
    selectedCard() {
      this.fetchDataForMerchant()
    },
  },
  async mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    if (this.walkingCustomer) {
      this.fields = this.fields.filter(f => f.key !== 'id' && f.key !== 'collected_cod' && f.key !== 'invoice_amount' && f.key !== 'commission_rate' && f.key !== 'commission_amount' && f.key !== 'deposited_date' && f.key !== 'merchant.ref_no' && f.key !== 'merchant_business')
      await this.$set(this.filters, 'orderable_type', 'walking')
      this.getWalkingCustomerList()
    } else {
      await this.$set(this.filters, 'orderable_type', 'merchant')
      this.getMerchantList()
    }
    this.statusOptions = JSON.parse(localStorage.getItem('finance_statuses'))
    this.getMerchantList()
    this.setMonthFilter()
    this.fetchDataForMerchant()
    this.readInvoiceTypeData()
    this.updateFilterCount()
  },
  methods: {
    setMonthFilter() {
      const currentRange = this.filters?.created_at
      if (currentRange?.startDate || currentRange?.endDate) return

      const currentMonth = this.monthFilter()
      this.updateDateRange('created_at', currentMonth)
    },
    async getMerchantList() {
      this.merchantOptions = localStorage.getItem('merchant_list') ? JSON.parse(localStorage.getItem('merchant_list')) : (await MerchantRepository.getMerchantListForDropdown()).data.data
      if (!localStorage.getItem('merchant_list')) localStorage.setItem('merchant_list', JSON.stringify(this.merchantOptions))
    },
    async getWalkingCustomerList() {
      this.walkingCustomers = localStorage.getItem('walking_customer_list') ? JSON.parse(localStorage.getItem('walking_customer_list')) : (await WalkingCustomerRepository.getWalkingCustomerDropdownList()).data.data
      if (!localStorage.getItem('walking_customer_list')) localStorage.setItem('walking_customer_list', JSON.stringify(this.walkingCustomers))
    },
    async fetchDataForMerchant() {
      this.dataLoading = true
      this.items = []
      const filterQuery = this.buildFilterQuery()
      try {
        const { data } = (await FinanceRepository.getMerchantFinanceDepositList(this.page, filterQuery, this.perPage, this.sort))
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async fetchDataForMerchantNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await FinanceRepository.getMerchantFinanceDepositListNoPagination(filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    handleChangePage(page) {
      this.page = page
      this.fetchDataForMerchant()
    },
    async downloadQueueExcel() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.__showJsonDownloadAlertForAllOrders()
        const filterQuery = this.buildFilterQuery()
        await FinanceRepository.downloadMerchantInvoiceExcelQueue(filterQuery)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    sortChanged(e) {
      const key = e.sortBy
      if (!key) {
        this.sort = ''
        this.fetchDataForMerchant()
        return
      }

      const active = e.sortDesc ? '-' : ''
      this.sort = `${active}${key}`
      if (this.page !== 1) {
        this.page = 1
        return
      }
      this.fetchDataForMerchant()
    },
    applyFilters() {
      this.fetchDataForMerchant()
      this.deselectAll()
      this.readInvoiceTypeData()
      this.updateFilterCount()
    },
    clearFilters() {
      this.filters = {
        created_at: {
          startDate: null,
          endDate: null,
        },
        return_charge: '',
      }
      this.$nextTick(() => {
        if (this.walkingCustomer) {
          this.$set(this.filters, 'orderable_type', 'walking')
        } else {
          this.$set(this.filters, 'orderable_type', 'merchant')
        }
        this.$nextTick(() => {
          this.fetchDataForMerchant()
          this.readInvoiceTypeData()
        })
      })
      this.updateFilterCount()
    },
    onClickOpenRequestPaymentModal(id) {
      this.$refs.merchant_payment_request_modal.openModal(id)
    },
    onClickShowRejectionReasons(id) {
      this.$refs.rejection_detail_modal.openModal(id, 'merchant')
    },
    selectAll() {
      this.depositSelected = this.items.map(n => n.id)
    },
    deselectAll() {
      this.depositSelected = []
    },
    onClickMakePayment() {
      this.$refs.make_deposit_action_modal.openModal(this.depositSelected, 'merchant')
    },
    onClickNewInvoice() {
      this.$router.push({ name: 'add-new-merchant-invoice' })
    },
    onClickRefresh() {
      this.fetchDataForMerchant()
      this.deselectAll()
      this.readInvoiceTypeData()
    },
    onClickInvoice(invoice) {
      if (this.walkingCustomer) {
        this.$router.push({
          name: 'walking-finance-invoice',
          params: {
            id: invoice,
          },
        })
      } else {
        this.$router.push({
          name: 'merchant-finance-invoice',
          params: {
            id: invoice,
          },
        })
      }
    },
    onClickSelectAllCheckbox() {
      if (this.selectAllCheckbox) {
        // If the "Select All" checkbox is checked, select all waybill numbers.
        this.depositSelected = this.items.map(n => n.id)
      } else {
        this.depositSelected = []
      }
    },
    async readInvoiceTypeData() {
      try {
        this.getAllInvoicesSummary()
        this.getPayableInvoicesSummary()
        this.getReceivableInvoicesSummary()
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async getAllInvoicesSummary() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await FinanceRepository.getAllInvoicesSummary(this.filterQuery))
        this.allInvoice.total = data.all_invoice.total
        const allInvoiceCount = Math.abs(data.all_invoice.sum ?? 0)
        this.allInvoice.count = allInvoiceCount
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getPayableInvoicesSummary() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await FinanceRepository.getPayableInvoicesSummary(this.filterQuery))
        this.payableInvoice.total = data.payable_invoice.total
        this.payableInvoice.count = data.payable_invoice.sum
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getReceivableInvoicesSummary() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await FinanceRepository.getReceivableInvoicesSummary(this.filterQuery))
        this.receivableInvoice.total = data.receivable_invoice.total
        const receivableInvoiceCount = Math.abs(data.receivable_invoice.sum ?? 0)
        this.receivableInvoice.count = receivableInvoiceCount
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onCardSelect(selectedCard, key, attribute) {
      this.selectedCard = selectedCard
      this.selectedKey = key
      this.attribute = attribute

      if (key && attribute) {
        this.filters = {
          ...this.filters,
          [`${attribute}`]: key, // Dynamically create filter like filter[invoice_amount_after_taxes]: payable
          [`${'orderable_type'}`]: 'merchant',
        }
      } else {
        this.filters = {
          ...this.filters,
          [`${'orderable_type'}`]: 'merchant',
        }
      }
    },
  },
}
</script>
<style lang="scss">
@import '../../@core/scss/vue/libs/vue-select.scss';
@media (max-width: 767px) {
  .add-margin-bottom {
    width: 100%;
    margin-bottom: 20px;
  }
  .pagination-text {
    font-size: 0.75rem;
  }
}
</style>
